import updateBlockAttributes from './updateBlockAttributes';
import updateTextAttributes from './updateTextAttributes';
import moveSelectionForward from './moveSelectionForward';

var isUpdatingAttributes = function isUpdatingAttributes(attrs) {
  return !!attrs;
};

var isUpdatingBlockAttributes = function isUpdatingBlockAttributes(attrs) {
  return attrs.type !== undefined || attrs.data !== undefined;
};

export default function retainOperation(editor, _ref) {
  var retain = _ref.retain,
      attributes = _ref.attributes;

  if (isUpdatingAttributes(attributes)) {
    if (isUpdatingBlockAttributes(attributes)) {
      return updateBlockAttributes(editor, retain, attributes);
    } else {
      return updateTextAttributes(editor, retain, attributes);
    }
  } else {
    return moveSelectionForward(editor, retain);
  }
}